var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParliamentBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.61 202.16 89.58 81.97 95.35 75.69 101.45 81.97 101.45 92.19 112.8 92.18 112.8 81.96 118.89 75.68 124.67 81.96 124.7 202.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "98.71 77.97 98.71 63.44 107.14 36.22 115.91 63.44 115.34 78.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "71.48 202.16 71.47 160.1 65.63 149.05 59.47 149.05 53.77 160.11 53.78 202.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "37.03 202.18 37.02 160.11 31.18 149.06 25.02 149.06 19.32 160.12 19.33 202.18 195.63 202.13 195.62 160.06 189.78 149.01 183.62 149.01 177.92 160.07 177.93 202.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "160.47 202.14 160.45 160.07 154.62 149.02 148.46 149.02 142.75 160.08 142.76 202.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.26,
    y1: 160.25,
    x2: 53.76,
    y2: 160.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 72.42,
    y1: 160.24,
    x2: 88.93,
    y2: 160.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 126.24,
    y1: 160.22,
    x2: 142.75,
    y2: 160.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 161.41,
    y1: 160.21,
    x2: 177.92,
    y2: 160.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 107.19,
    cy: 114.99,
    r: 7.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.91,36.22V11.89s9.53,5.62,22.49,0V24.07s-9.06,6.56-20.93,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParliamentBuilding);
export default __webpack_public_path__ + "static/media/PARLIAMENT_BUILDING.2ed540303cbe1ceedb67feb00e08276e.svg";
export { ForwardRef as ReactComponent };